<script setup lang="ts">
withDefaults(
  defineProps<{
    title: string
    to?: string
    linkLabel?: string
  }>(),
  {
    linkLabel: "View all",
  },
)
</script>

<template>
  <div class="mb-2 flex items-center justify-between">
    <h2 class="text-highlighted text-sm font-semibold">{{ title }}</h2>
    <UButton
      v-if="to"
      :label="linkLabel"
      variant="link"
      color="primary"
      trailing-icon="i-lucide-arrow-right"
      size="sm"
      :to="to"
    />
  </div>
</template>
